// Spec 056 (US6) — o que o cliente vê DEPOIS de clicar em "confirmar a compra".
//
// Nenhum texto daqui afirma que a compra nao foi cobrada: no bug 8005 essa frase
// era falsa - o pedido existia, o bilhete estava sendo emitido e o cartao ja
// tinha sido cobrado.

// Situacao do pedido exposta pelo endpoint "me/orders/{id}" da MuviHub
// (ClientOrderSituation no backend). "Em analise" entrou na spec 056 (US5):
// o pedido nao deu certo e o valor do cliente continua com a empresa,
// aguardando acao manual.
export const ORDER_SITUATION = {
	IN_PROGRESS: 'Em processamento',
	COMPLETED: 'Concluído',
	CANCELLED: 'Cancelado',
	UNDER_REVIEW: 'Em análise',
	REBOOKED: 'Remarcado',
}

// Situacoes em que nao ha mais nada a esperar - o polling da tela "emitindo"
// pode parar. "Em analise" encerra tambem: o desfecho automatico acabou, e o
// que falta e acao humana.
export const ORDER_SITUATION_FINAL = [
	ORDER_SITUATION.COMPLETED,
	ORDER_SITUATION.CANCELLED,
	ORDER_SITUATION.UNDER_REVIEW,
]

export const POST_PAYMENT_TIMINGS = {
	// Teto do request de checkout no axios. Spec 056 (T127, D42): 60s = acima dos 45s
	// que o Hub espera o legado + 10s da recuperacao da reserva; menos que isso o
	// axios aborta antes de o Hub responder e perdemos a resposta boa. O proxy entre
	// o site e o Hub precisa ser >= 70s. Medicao de producao (30 dias ate 06/10):
	// criacao p99 17,3s; so 4 em 11.865 passaram de 45s.
	CHECKOUT_REQUEST_TIMEOUT_MS: 60000,

	EMISSION_POLL_INTERVAL_MS: 5000,

	// Spec 056 (T125, D39): com o Pix JA PAGO (campo paymentReceived do Hub), quanto
	// a tela "emitindo" espera, contando do momento em que viu o pagamento, antes de
	// tranquilizar o cliente e convidar a acompanhar em Minhas Compras. 240s = o teto
	// da emissao no Hub. Nao e desistencia: o polling continua.
	EMISSION_INVITE_AFTER_MS: 240000,

	// Quantas consultas seguidas podem falhar antes de a tela desistir do polling.
	// Antes bastava UMA para o modal de erro aparecer - um soluco de rede durante
	// uma emissao saudavel virava "sua compra nao foi cobrada".
	EMISSION_MAX_CONSECUTIVE_ERRORS: 5,
}

export const POST_PAYMENT_MESSAGES = {
	// Quando a tela desiste de consultar (nao afirma que nao foi cobrada).
	EMISSION_GAVE_UP_TITLE: 'Não conseguimos acompanhar a emissão agora',
	EMISSION_GAVE_UP_BODY:
		'Isso não significa que a compra falhou. Acompanhe o resultado em Minhas Compras.',

	GO_TO_MY_PURCHASES: 'Ir para Minhas Compras',

	// Pix ja pago e emissao passando dos 240s (o polling continua por tras). So
	// aparece com o pagamento confirmado pelo Hub: o bug 8067 mostrou este texto
	// sobre um Pix NAO pago, por cima do QR Code, e por isso ele tinha saido.
	EMISSION_SLOW_TITLE: 'A emissão está em andamento',
	EMISSION_SLOW_BODY:
		'Recebemos o seu pagamento e os bilhetes continuam sendo emitidos — não é preciso refazer a compra. ' +
		'Você pode acompanhar em Minhas Compras; avisaremos por e-mail assim que ficarem prontos.',
	KEEP_WAITING: 'Continuar aguardando',

	// Minhas Compras, pedido ainda sem bilhete.
	NO_TICKETS_IN_PROGRESS:
		'Estamos emitindo os bilhetes deste pedido. Eles aparecem aqui assim que ficarem prontos.',
	NO_TICKETS_UNDER_REVIEW:
		'Este pedido está em análise pela nossa equipe. Entraremos em contato para concluir o atendimento.',
}
